import React, { Component } from 'react';
import memoizeOne from 'memoize-one';
import { LightningsData, Lightning, CurrentLocation } from '@ro-atoms/RoTooltip/RoTooltip.types';
import Icon from '@ro-atoms/Icon';
import { distance } from '@ro-utils/common/helpers';
import { Cell, BodyRow } from '../../../RoTable';
import { SpIconWrapper } from '../../RoTooltip.styles';
import { Coordinate } from 'ol/coordinate';

type Props = {
  lightningsData?: LightningsData;
  currentLocation: CurrentLocation;
};

export class Lightnings extends Component<Props> {
  inRadius = (item: Lightning) => {
    const { currentLocation } = this.props;
    const coord: Coordinate = currentLocation?.original;
    const dist = coord && distance(coord[1], coord[0], item[0][0], item[0][1]);
    return dist && dist < 0.5 && dist;
  };
  getDistances = () => {
    const data = this.props.lightningsData?.data;
    return data && data.reverse().filter(memoizeOne(this.inRadius));
  };
  render() {
    const dist = this.getDistances();
    const noLightnings = dist?.length;
    return noLightnings ? (
      <BodyRow>
        <Cell maxWidth={200}>
          <SpIconWrapper bg="#000" color="#fff" size={30}>
            <Icon weather={true} name={'earthquake'} />
          </SpIconWrapper>
          <b>Uderzenia pioruna</b>
        </Cell>
        <Cell maxWidth={200}>
          <b>{noLightnings}</b> w promieniu 0,5 km
        </Cell>
      </BodyRow>
    ) : null;
  }
}
